export default "__VITE_ASSET__BAPsTK7N__"